/**
 * Validation utilities index
 * 
 * This file exports all validation utilities for easy importing
 */

// NIF validation utilities
export {
  validateNif,
  formatNif,
  cleanNif
} from './nifValidation';

// ID Card validation utilities
export {
  validateIdNumber,
  formatIdNumber,
  cleanIdNumber,
  isValidIdNumberFormat
} from './idCardValidation';

// Common validation utilities
export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePostalCode = (code) => {
  if (!code || typeof code !== 'string') {
    return false;
  }
  const re = /^\d{4}-\d{3}$/;
  return re.test(code);
};
